import React from "react";
import { SearchTypeEnum, ISearchValue } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useRemainingModel } from "../remainingModel";
import { useGlobalModel } from "@/model/globalModel";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData,
    } = useRemainingModel();
    const { fetchCustomerList, fetchSupplierList, shopDs } = useGlobalModel(() => []);
    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            placeholder: "从属门店",
            fieldName: "shopCode",
            options: shopDs.map(item => ({ ...item, value: item.code }))
        },
        ...[searchParam.supplier === "1" ? {
            type: SearchTypeEnum.AsyncSelect,
            key: "supplier",
            xxl: 4,
            span: 4,
            placeholder: "供应商",
            fieldName: "partnerCode",
            size: "small",
            selectfetchList: fetchSupplierList,
        } : {
            type: SearchTypeEnum.AsyncSelect,
            key: "customer",
            xxl: 4,
            span: 4,
            placeholder: "客户",
            fieldName: "partnerCode",
            size: "small",
            selectfetchList: fetchCustomerList,
        }],
        {
            type: SearchTypeEnum.CheckBox,
            xxl: 4,
            span: 4,
            placeholder: "供应商",
            fieldName: "supplier",
            size: "small"
        }
    ]

    return (
        <YhPageHeader
            title="剩余金额差异"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}